import { render, staticRenderFns } from "./ProductSpecsEdit.vue?vue&type=template&id=05346d18"
import script from "./ProductSpecsEdit.vue?vue&type=script&lang=js"
export * from "./ProductSpecsEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports